



















import Vue from "vue";
import Api from "../../base/api.typings";
import Component from "vue-class-component";
import routerService from '../../base/router-service';
import empresaAtualService from '../../features/empresa-atual/empresa-atual-service';
import authService from '../../features/api-authorization/authorize-service';

@Component
export default class ChamadoEnviado extends Vue {
    created() {
        this.obterEmpresaAreaAtual();
    }

    servicoGrupos: Api.App.Server.Servico.ListarServicoGrupos.Dto[] = [];

    tipoChamado: string = window.location.pathname;

    empresaAtual: string = null;

    async abrirChamados() {
        await routerService.goTo('chamado-listar');
    }        

    async obterEmpresaAreaAtual() {
        this.empresaAtual = await empresaAtualService.obterEmpresaAtualId();
    }

    async logout() {
        if (this.empresaAtual == null) {
            await authService.signOut({ returnUrl: location.origin });
        }
    }
}
